/**
 * The panel's half of the lot price rule (`R-LOT-32`): at least Stripe's smallest charge, or at a
 * fixed price exactly nothing, which makes the lot free.
 *
 * The server's half is `validLotPrice` in `packages/core/src/shows/allocation.ts` and is the one
 * that decides; this one exists so the form refuses before anything is sent, and says why beside
 * the field. The floor is copied from `MINIMUM_CHARGE_PENCE` there — the panel does not import
 * `core` — and `apps/host/test/price.test.ts` pins it.
 */

/** Stripe's smallest GBP charge, in pence. */
export const MINIMUM_PRICE_PENCE = 30;

const MONEY = /^\d{1,8}(\.\d{1,2})?$/;

/** Why `value` cannot be a lot's price, as a key under `lots.priceProblem`, or `undefined`. */
export function priceProblem(
  value: string,
  saleMode: "fixed" | "auction",
): "format" | "minimum" | "minimumAuction" | "freeAuction" | undefined {
  const typed = value.trim();
  if (!MONEY.test(typed)) return "format";
  const pence = Math.round(Number(typed) * 100);
  if (pence === 0) return saleMode === "fixed" ? undefined : "freeAuction";
  if (pence >= MINIMUM_PRICE_PENCE) return undefined;
  // Told apart because the fixed-price message offers free as the alternative.
  return saleMode === "fixed" ? "minimum" : "minimumAuction";
}
